export default "__VITE_ASSET__CfY1wMQP__"